function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M150.72 27.87c4.58 3.84 7.14 8.13 7.14 12.63 0 16.55-34.44 30-76.93 30-3.67 0-9.09.19-12.63 0M49.86 67.92c-27-4.65-45.83-15.18-45.83-27.42 0-8 8-15.25 21.13-20.63"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M83.04 85.2L68.31 70.47l14.73-14.74M36.86 4.4h19.5s-9.5 10-11.5 15.5h2c6.6 0 11.5 3.9 11.5 10.5s-4.9 11-11.5 11a20.13 20.13 0 01-10.19-3M90.86 4.4c-10 .5-17.65 8.6-19 18.5-1.38 10.12.78 18.5 11 18.5 0 0 9.93.55 9-13-1-14.5-20-5.5-20-5.5M126.86 22.7c0 10.33-3.5 18.7-11.5 18.7-7.5 0-11.5-8.4-11.5-18.7s4-18.7 11.5-18.7 11.5 8.37 11.5 18.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 145.36,
  cy: 10.4,
  r: 6
});

var Svg360Degrees = function Svg360Degrees(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 161.86 89.2",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3);
};

export default Svg360Degrees;